import React from "react";
import "./ZoomLoading.css";

const ZoomLoading = () => {
  return (
    <div className="zoom-loading-container h-100 flex-column d-flex align-items-center justify-content-center"></div>
  );
};
export default ZoomLoading;
